var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 95 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8499 95.7794L50.5658 95.459C50.5658 95.459 49.1766 100.213 46.9009 100.213H44.7034C42.4278 100.213 40.583 98.3885 40.583 96.1382L40.8499 95.7794Z",
    fill: "#70889A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7359 86.9006V83.076C53.7359 78.4546 58.7857 74.0834 62.0615 70.9648C66.679 66.5713 69.1062 60.6687 69.1062 53.7542C69.1062 41.1055 58.8228 30.8419 46.1147 30.8067C33.4065 30.7715 23.066 40.978 22.9952 53.6265C22.9951 53.6691 22.9951 53.7116 22.9952 53.7542C22.9952 60.4217 25.5265 66.7243 30.0399 70.9648C33.2981 74.0261 38.3656 78.4068 38.3656 83.076V86.9006",
    fill: "#FFE676"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5207 94.5077C40.0309 94.5077 39.6338 94.0947 39.6338 93.5852C39.6338 93.0757 39.6808 92.1309 40.1706 92.1309L50.6312 92.6627C51.121 92.6627 51.5181 93.0757 51.5181 93.5852C51.5181 94.0947 51.121 94.5077 50.6312 94.5077H40.5207Z",
    fill: "#70889A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6807 31.3529L75.2248 18.9238L82.8926 19.2643L68.8489 32.7096L67.6807 31.3529Z",
    fill: "#FFE676",
    stroke: "#FFE676",
    strokeWidth: 3.06496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8512 60.8548L91.7414 64.5864L92.5005 68.3L76.2179 62.3216L76.8512 60.8548Z",
    fill: "#FFE676",
    stroke: "#FFE676",
    strokeWidth: 3.06496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5054 23.8608L40.5532 5.15384L49.6989 4.86734L47.2693 24.1828L45.5054 23.8608Z",
    fill: "#FFE676",
    stroke: "#FFE676",
    strokeWidth: 3.06496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2781 33.5154L5.9015 30.176L10.1118 24.8275L20.2964 33.6373L17.2781 33.5154Z",
    fill: "#FFE676",
    stroke: "#FFE676",
    strokeWidth: 3.06496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9935 59.8751L2.64281 65.5446L2.91786 59.9662L15.327 57.967L12.9935 59.8751Z",
    fill: "#FFE676",
    stroke: "#FFE676",
    strokeWidth: 3.06496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1519 90.705C37.657 90.705 37.2559 90.3111 37.2559 89.8251C37.2559 89.3392 37.657 88.9452 38.1519 88.9452L53.4993 88.3281C53.9942 88.3281 54.3693 89.3392 54.3693 89.8251C54.3693 90.3111 53.9681 90.705 53.4732 90.705H38.1519Z",
    fill: "#70889A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2398 87.7241C45.0758 87.5558 44.3882 88.2915 44.3882 88.0534L44.9837 66.6276C44.9837 66.1319 45.299 66.8868 45.7819 66.8868C46.2648 66.8868 46.7323 66.1319 46.7323 66.6276L48.6665 88.2883C48.6665 88.5263 46.6402 87.5558 46.4763 87.7241C46.3123 87.8924 46.0899 87.987 45.858 87.987C45.6261 87.987 45.4038 87.8924 45.2398 87.7241Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8618 67.4095C42.9516 67.4095 39.3787 64.8223 39.2281 64.7122C38.9699 64.5234 38.6821 63.1741 38.6821 63.1741C38.6821 63.1741 43.9429 65.6393 45.8618 65.6393C47.7807 65.6393 51.8439 62.3781 52.7394 61.7251C53.1387 61.4334 52.8947 64.4205 52.4955 64.7122C52.3448 64.8223 48.7719 67.4095 45.8618 67.4095Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.f8e94e249a9782cfe4f76b485d691e8d.svg";
export { ForwardRef as ReactComponent };